"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _tcomb = require("tcomb");

var t = _interopRequireWildcard(_tcomb);

var _lodash = require("lodash");

var _ = _interopRequireWildcard(_lodash);

var _AppDataField = require("../AppDataField");

var _ReportDetailTableRowFieldTemplate = require("../../../containers/reportDetail/ReportDetailTableRowFieldTemplate");

var _ReportDetailTableRowFieldTemplate2 = _interopRequireDefault(_ReportDetailTableRowFieldTemplate);

var _ReportDetailTableFieldTemplate = require("../../../containers/reportDetail/ReportDetailTableFieldTemplate");

var _ReportDetailTableFieldTemplate2 = _interopRequireDefault(_ReportDetailTableFieldTemplate);

var _actions = require("../actions");

var reportDetailActions = _interopRequireWildcard(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableNoColumnsAppDataField = function TableNoColumnsAppDataField(dataField, contentDataField, reportData) {
    var _this = this;

    var isWithinTable = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

    _classCallCheck(this, TableNoColumnsAppDataField);

    // Searches within a table if a referenced table row already exists
    // translates raw tcomb form data to TableRow for structured data handling.
    // ATTENTION: This function is indended to identify the row directly based on the current stored value (content)
    // Therefore this only works with tables that HAVE columns set!
    this.identifyTableRow = function (rowId) {
        return _.find(_this.rows, { ref: rowId });
    };
    this.buildContentDataFromRows = function () {
        return {
            data: {
                rows: _.chain(_this.rows).map(function (row) {
                    return {
                        fields: [],
                        ref: row.ref
                    };
                }).value()
            },
            type: "table",
            uid: _this.dataField.uid
        };
    };
    this.generateNewRow = function (appDataFields, refUid) {
        var columnAppDataFields = appDataFields;
        var tcombSchema = t.struct({});
        return {
            schema: tcombSchema,
            ref: refUid,
            appDataFields: []
        };
    };
    this.generateColumnsOfRow = function (row) {
        return []; // no columns!
    };
    this.appSchemaFieldOptions = function (formattedMessage) {
        var disabled = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

        var field = {};
        _.set(field, _this.key(), {
            label: _this.isWithinTable ? null : _this.dataField.title,
            help: (0, _AppDataField.helpContainer)(true, _this.dataField.description),
            disableAdd: true,
            disableOrder: true,
            disableRemove: true,
            disabled: disabled,
            template: function template(locals) {
                return _this.template(locals, formattedMessage);
            },
            // dynamic item options
            item: function item(value) {
                // finds row for current value
                // console.debug("appSchemaFieldOptions: identifyTableRow", value);
                var row = _this.identifyTableRow(value.id);
                // merge schemeoptions of data fields
                var options = {};
                return {
                    fields: {
                        id: {
                            type: "hidden"
                        }
                    },
                    disabled: disabled,
                    auto: "none",
                    template: function template(locals) {
                        return _this.rowTemplate(locals, formattedMessage);
                    }
                };
            }
        });
        return field;
    };
    this.appSchemaObject = function () {
        var schema = {};
        schema = _defineProperty({}, _this.key(), t.list(t.struct({
            id: t.String
        })));
        return schema;
    };
    this.appSchemaStruct = function () {
        return t.struct(_this.appSchemaObject(), _this.dataField.uid);
    };
    this.setValue = function (value) {
        value = value || null;
        if (value) {
            _.chain(value).forEach(function (row) {
                // console.debug("setValue: identifyTableRow", row);
                var tableRow = _this.identifyTableRow(row.id);
            }).value();
        }
        _this.contentDataField = _this.buildContentDataFromRows();
    };
    // overwrite current value with new value
    this.addItem = function (dispatch, refUid) {
        // generate empty AppDataFields
        var appDataFields = _this.generateColumnsOfRow([]);
        var row = _this.generateNewRow(appDataFields, refUid);
        _this.rows = _this.rows.concat(Array(row));
        _this.contentDataField = _this.buildContentDataFromRows();
        dispatch(reportDetailActions.updateReportWithAppDataField(_this)).then(function (value) {
            return dispatch(reportDetailActions.saveSelectedReport());
        });
    };
    this.removeItem = function (dispatch, refUid) {
        _this.rows = _.chain(_this.rows).filter(function (row) {
            return row.ref !== refUid;
        }).value();
        var currentFormValue = _this.currentFormValue();
        dispatch(reportDetailActions.updateReportWithAppDataField(_this)).then(function (value) {
            return dispatch(reportDetailActions.saveSelectedReport());
        });
    };
    this.template = function (locals, formattedMessage) {
        var usedUids = _.chain(_this.rows).map(function (row) {
            return row.ref;
        }).value();
        var rowTitles = _.chain(_this.columnDataFieldDefinitions).map(function (dataField) {
            return (0, _AppDataField.labelHelper)(dataField.title, dataField.isMandatory, dataField.isWithinTable, formattedMessage);
        }).value();
        return React.createElement("div", { style: { width: _AppDataField.containerWidth } }, React.createElement(_ReportDetailTableFieldTemplate2.default, { dataFieldUuid: _this.dataField.uid, usedUids: usedUids, title: _this.dataField.title, addItem: _this.addItem, typeDefinitionUid: _this.dataField.refUid, locals: locals, rowTitles: rowTitles }));
    };
    this.rowTemplate = function (locals, formattedMessage) {
        // console.debug("rowTemplate: identifyTableRow", locals);
        var currentRow = _this.identifyTableRow(locals.value.id);
        return React.createElement("div", { style: { width: _AppDataField.containerWidth } }, React.createElement(_ReportDetailTableRowFieldTemplate2.default, { locals: locals, removeItem: _this.removeItem, refUid: currentRow ? currentRow.ref : null }));
    };
    this.key = function () {
        return _this.dataField.uid;
    };
    this.currentFormValue = function () {
        var rowData = [];
        if (_this.rows) {
            _this.contentDataField = _this.buildContentDataFromRows();
            var rows = _.chain(_this.rows).map(function (tableRow, index) {
                var rowData = {
                    id: tableRow.ref // id must be set to identify the row!
                };
                return rowData;
            }).value();
            return rows;
        }
        return null;
    };
    this.copy = function () {
        return new TableNoColumnsAppDataField(_this.dataField, _this.contentDataField, _this.reportData);
    };
    this.contentDataField = contentDataField;
    this.dataField = dataField;
    this.reportData = reportData;
    this.isWithinTable = isWithinTable;
    this.columnDataFieldDefinitions = [];
    if (contentDataField) {
        var table = contentDataField.data;
        this.rows = _.chain(table.rows).map(function (row) {
            var columnAppDataFields = _this.generateColumnsOfRow(row.fields);
            return _this.generateNewRow(columnAppDataFields, row.ref);
        }).value();
        // build union type
        var typeStructs = _.chain(this.rows).map(function (row) {
            return row.schema;
        }).value();
        if (typeStructs.length > 1) {
            this.rowTypes = t.union(typeStructs, "ListItemUnion");
            this.rowTypes.dispatch = function (value) {
                // extract ref id from object key
                // console.debug("rowTemplate: identifyTableRow", value);
                var row = _this.identifyTableRow(value.id);
                return row.schema;
            };
        } else if (typeStructs.length === 1) {
            var type = typeStructs[0];
            this.rowTypes = type;
        }
    } else {
        this.rows = [];
    }
    this.contentDataField = Object.assign({}, contentDataField, {
        type: "table",
        uid: dataField.uid
    });
    this.setValue(this.currentFormValue());
};

exports.default = TableNoColumnsAppDataField;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reportDetail/fields/TableNoColumnsAppDataField.tsx
 ** module id = 640
 ** module chunks = 0
 **/